<div *ngIf="isLoading; else page_content" data-test="loader" class="loader__container" [class.interactive]="isInteractive">
  <mat-spinner></mat-spinner>
</div>
<ng-template #page_content><ng-content></ng-content></ng-template>
